import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const BtDancerImage = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "bt_Dancer_r.png" }) {
          childImageSharp {
            fluid(maxWidth: 900) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Img  fluid={data.placeholderImage.childImageSharp.fluid}  style={{width: "9em", marginLeft: "37px"}}/>}
  />
)
export default BtDancerImage
